

import React, { memo, useCallback } from 'react';
import cx from 'classnames';
import { ToolTip } from '../../../ui-kit';
import '../styles/_heatmap-cell.scss';








function HeatmapCell({ children, className, toolTipLabel, onCellClick }) {
  const onClick = useCallback(
    () => onCellClick && onCellClick(), [onCellClick]
  );

  const innerHeatmapCell =
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
  <div
    className={cx(
      'heatmap-cell', {
        'heatmap-cell--clickable': onCellClick
      }, className)}
    onClick={onClick}>

      {children}
    </div>;


  if (!onCellClick) {
    return innerHeatmapCell;
  }

  return (
    <ToolTip id="View" label={toolTipLabel} place="bottom">
      {innerHeatmapCell}
    </ToolTip>);

}

export default memo(HeatmapCell);